<template>
  <PublicPageShell v-if="isNotFoundPage">
    <div class="flex min-h-[100dvh] items-center justify-center px-5 py-12 sm:px-8">
      <section class="w-full max-w-xl border border-neutral-200 bg-white px-6 py-10 shadow-xl sm:px-10">
        <div class="scio-text-data scio-weight-semibold uppercase tracking-[0.18em] text-neutral-500">Scio</div>
        <div class="mt-5 flex items-start gap-4">
          <div class="grid h-12 w-12 shrink-0 place-items-center bg-scio-yellow-p3 text-xl font-semibold text-neutral-950">404</div>
          <div>
            <h1 class="scio-text-title scio-weight-heading text-neutral-950">That page is not available</h1>
            <p class="mt-2 scio-text-body leading-6 text-neutral-600">The link may be out of date, or the page may have moved. Choose a destination below to continue.</p>
          </div>
        </div>
        <p v-if="requestedPath" class="mt-6 border-l-2 border-neutral-200 pl-3 scio-text-meta text-neutral-500">Requested path: {{ requestedPath }}</p>
        <div class="mt-8 flex flex-wrap items-center gap-3">
          <router-link :to="{ name: 'project-list' }" class="scio-se-save-action scio-se-save-action-dirty inline-flex h-10 w-10 items-center justify-center" title="Go to Programmes" aria-label="Go to Programmes">
            <img src="/icons/scio-contracts-02.svg" alt="" aria-hidden="true" class="h-4 w-4" />
          </router-link>
          <button v-if="canGoBack" type="button" class="scio-se-secondary-action inline-flex h-10 w-10 items-center justify-center" title="Go back" aria-label="Go back" @click="goBack">
            <img src="/icons/scio-chevron-left-01.svg" alt="" aria-hidden="true" class="h-4 w-4" />
          </button>
        </div>
      </section>
    </div>
  </PublicPageShell>
</template>

<script>
import PublicPageShell from "@/common/components/layout/PublicPageShell.vue";

export default {
  name: "PageNotFoundRedirect",
  components: { PublicPageShell },
  computed: {
    isNotFoundPage() {
      return this.$route?.name === "not-found";
    },
    requestedPath() {
      return this.$route?.query?.path || "";
    },
    canGoBack() {
      return typeof window !== "undefined" && window.history.length > 1;
    },
  },
  mounted() {
    if (!this.isNotFoundPage) {
      this.$router.replace({
        name: "not-found",
        query: { path: this.$route.path },
      });
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
